import type { CompetitorProduct, Product } from "@/graphql/codegen/graphql"

export type AssociatedProduct = Product | CompetitorProduct

export const isAkrochemProduct = (product: AssociatedProduct): product is Product => {
  return "productId" in product && typeof product.productId === "number"
}

export const isCompetitorProduct = (product: AssociatedProduct): product is CompetitorProduct => {
  return "competitorProductId" in product && typeof product.competitorProductId === "string"
}
